import React from 'react';
import { Link } from 'react-router-dom';
import sadhanImg from '../assets/images/SadhanPalakuri.jpeg';
import './Doctors.css';

export default function Doctors() {
  return (
    <div>

      {/* HERO */}
      <section className="page-hero">
        <div className="container">
          <div className="breadcrumb"><Link to="/">Home</Link><span className="sep">›</span><span>Our Doctors</span></div>
          <h1>Meet Our Specialists</h1>
          <p>Fellowship-trained experts in pain medicine, sports orthopaedics, and regenerative medicine — dedicated to your recovery.</p>
        </div>
      </section>

      

      {/* DR. SADHAN PALAKURI */}
      <section className="section" style={{background:'#F8FAFC'}}>
        <div className="container">
          <div className="dr-card reverse">
            <div className="dr-img-wrap">
              <img src={sadhanImg} alt="Dr. Sadhan Palakuri" className="dr-photo" />
              <div className="dr-accent" style={{background:'linear-gradient(135deg,#1565C0,#00A8E8)'}}/>
            </div>
            <div className="dr-info">
              <div className="tag-line"><span>Sports Orthopaedics Specialist</span></div>
              <h2 className="dr-name">Dr. Sadhan Palakuri</h2>
              <p className="dr-qual-tag">MBBS, MS.Ortho, FIAS, FIJR, FIPM</p>
              <div className="dr-roles">
                <div className="dr-role" style={{borderColor:'#1565C044',color:'#1565C0',background:'#1565C00f'}}>● Consultant Sports Orthopaedics</div>
                <div className="dr-role" style={{borderColor:'#1565C044',color:'#1565C0',background:'#1565C00f'}}>● Arthroscopy Knee &amp; Shoulder Specialist</div>
                <div className="dr-role" style={{borderColor:'#1565C044',color:'#1565C0',background:'#1565C00f'}}>● Regenerative OrthoBiologist</div>
              </div>
              <p className="dr-bio">Dr. Sadhan Palakuri is a fellowship-trained sports orthopaedic surgeon with expertise in arthroscopic surgery and regenerative orthobiology. He has treated hundreds of athletes and sports professionals, helping them return to peak performance through minimally invasive techniques. His specialized training in joint preservation and biological reconstruction sets him apart as a leader in sports orthopaedic care.</p>
              <div className="dr-exp-box">
                <div className="dr-exp-title">Areas of Expertise</div>
                <div className="dr-exp-grid">
                  <div className="dr-exp-item"><span style={{background:'#1565C0'}} className="exp-dot"/>Sports Orthopaedics</div>
                  <div className="dr-exp-item"><span style={{background:'#1565C0'}} className="exp-dot"/>Knee Arthroscopy</div>
                  <div className="dr-exp-item"><span style={{background:'#1565C0'}} className="exp-dot"/>Shoulder Arthroscopy</div>
                  <div className="dr-exp-item"><span style={{background:'#1565C0'}} className="exp-dot"/>ACL Reconstruction</div>
                  <div className="dr-exp-item"><span style={{background:'#1565C0'}} className="exp-dot"/>Knee Replacement</div>
                  <div className="dr-exp-item"><span style={{background:'#1565C0'}} className="exp-dot"/>Regenerative OrthoBiologics</div>
                </div>
              </div>
              <div className="dr-quals">
                <div>🎓 MBBS — Medical Graduate</div>
                <div>🎓 MS Orthopaedics</div>
                <div>🏅 FIAS — Fellowship in Arthroscopy &amp; Sports Medicine</div>
                <div>🏅 FIJR — Fellowship in Joint Replacement</div>
                <div>🏅 FIPM — Fellowship in Pain Medicine</div>
                <div>📍 Hyderabad, Telangana</div>
              </div>
              <Link to="/contact" className="btn-book" style={{background:'#1565C0'}}>Book with Dr. Sadhan →</Link>
            </div>
          </div>
        </div>
      </section>

      <div className="dr-divider"/>

      {/* DR. GEETHA BHARGAVI */}
      <section className="section">
        <div className="container">
          <div className="dr-card">
            <div className="dr-img-wrap">
              <img src="http://mahavitech.com/images/GeethaBhargavi.jpeg?w=600&q=80" alt="Dr. Geetha Bhargavi" className="dr-photo" />
              <div className="dr-accent" style={{background:'linear-gradient(135deg,#0D4E9A,#00A8E8)'}}/>
            </div>
            <div className="dr-info">
              <div className="tag-line"><span>Pain Medicine Specialist</span></div>
              <h2 className="dr-name">Dr. Geetha Bhargavi</h2>
              <p className="dr-qual-tag">MBBS, MD.Anaesth, FIPM</p>
              <div className="dr-roles">
                <div className="dr-role" style={{borderColor:'#0D4E9A44',color:'#0D4E9A',background:'#0D4E9A0f'}}>● Consultant Pain Physician</div>
                <div className="dr-role" style={{borderColor:'#0D4E9A44',color:'#0D4E9A',background:'#0D4E9A0f'}}>● Interventional Spine Specialist</div>
                <div className="dr-role" style={{borderColor:'#0D4E9A44',color:'#0D4E9A',background:'#0D4E9A0f'}}>● Regenerative Medicine Expert</div>
              </div>
              <p className="dr-bio">Dr. Geetha Bhargavi is a fellowship-trained pain physician specializing in interventional spine procedures and regenerative medicine. With expertise in PRP, BMAC, and stem cell therapies, she helps patients achieve lasting relief from chronic pain without major surgery. Her patient-first approach and precision in diagnosis have made her one of Hyderabad's most trusted pain specialists.</p>
              <div className="dr-exp-box">
                <div className="dr-exp-title">Areas of Expertise</div>
                <div className="dr-exp-grid">
                  <div className="dr-exp-item"><span style={{background:'#0D4E9A'}} className="exp-dot"/>Chronic Pain Management</div>
                  <div className="dr-exp-item"><span style={{background:'#0D4E9A'}} className="exp-dot"/>Spine Interventions</div>
                  <div className="dr-exp-item"><span style={{background:'#0D4E9A'}} className="exp-dot"/>PRP &amp; BMAC Therapy</div>
                  <div className="dr-exp-item"><span style={{background:'#0D4E9A'}} className="exp-dot"/>Stem Cell Therapy</div>
                  <div className="dr-exp-item"><span style={{background:'#0D4E9A'}} className="exp-dot"/>Nerve Blocks</div>
                  <div className="dr-exp-item"><span style={{background:'#0D4E9A'}} className="exp-dot"/>Facet Joint Injections</div>
                </div>
              </div>
              <div className="dr-quals">
                <div>🎓 MBBS — Medical Graduate</div>
                <div>🎓 MD Anaesthesiology</div>
                <div>🏅 FIPM — Fellowship in Pain Medicine</div>
                <div>📍 Hyderabad, Telangana</div>
              </div>
              <Link to="/contact" className="btn-book">Book with Dr. Geetha →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* WHY OUR DOCTORS */}
      <section className="section">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:52}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Our Approach</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Why Patients Trust <span style={{color:'#00A8E8'}}>Our Team</span></h2>
          </div>
          <div className="why-grid">
            <div className="why-card"><div className="w-icon">🎓</div><h3>Fellowship Trained</h3><p>Both doctors hold multiple national and international fellowships in their respective specialties.</p></div>
            <div className="why-card"><div className="w-icon">🧬</div><h3>Regenerative First</h3><p>They exhaust all biological and minimally invasive options before ever recommending surgery.</p></div>
            <div className="why-card"><div className="w-icon">🤝</div><h3>Patient-First Care</h3><p>Every consultation starts with listening. Treatment plans are built around your specific condition and goals.</p></div>
            <div className="why-card"><div className="w-icon">⚡</div><h3>Faster Recovery</h3><p>Minimally invasive techniques mean most patients return to full activity in weeks, not months.</p></div>
            <div className="why-card"><div className="w-icon">🎯</div><h3>Precision Diagnosis</h3><p>Advanced imaging and biomechanical analysis to find the exact root cause of pain.</p></div>
            <div className="why-card"><div className="w-icon">♻️</div><h3>Integrated Team</h3><p>Pain medicine, orthopaedic surgery and physiotherapy working together under one roof.</p></div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{background:'#0D4E9A',padding:'72px 0',textAlign:'center'}}>
        <div className="container">
          <h2 style={{fontSize:'clamp(26px,3vw,38px)',fontWeight:800,color:'#fff',marginBottom:16}}>Ready to Consult Our Specialists?</h2>
          <p style={{fontSize:16,color:'rgba(255,255,255,0.78)',maxWidth:500,margin:'0 auto 32px'}}>Book an appointment with Dr. Geetha or Dr. Sadhan today.</p>
          <div style={{display:'flex',gap:16,justifyContent:'center',flexWrap:'wrap'}}>
            <Link to="/contact" className="btn-book" style={{fontSize:16,padding:'14px 32px'}}>Book Appointment →</Link>
            <Link to="/treatments/pain-medicine" style={{fontSize:16,padding:'14px 32px',borderRadius:8,background:'rgba(255,255,255,0.15)',color:'#fff',fontWeight:700,textDecoration:'none',border:'1.5px solid rgba(255,255,255,0.3)',display:'inline-flex'}}>View Treatments</Link>
          </div>
        </div>
      </section>

    </div>
  );
}
